"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require("react-intl");

var _collection_utility = require("common-utilities/src/collection_utility");

var _date_range_dropdown = require("./global_components/date_range_dropdown");

var _date_range_dropdown2 = _interopRequireDefault(_date_range_dropdown);

var _string_utility = require("common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _click_or_escape_outside = require("./click_or_escape_outside");

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _single_date_picker_wrapper = require("./global_components/single_date_picker_wrapper");

var _single_date_picker_wrapper2 = _interopRequireDefault(_single_date_picker_wrapper);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _ramda = require("ramda");

var _date_formatter = require("common-utilities/src/date_formatter");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _functional_utility = require("common-utilities/src/functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var setTooltipWrapper = function setTooltipWrapper(text) {
  return _react2.default.createElement(
    "span",
    { "data-testid": "tooltip-error",
      id: "tooltip-error",
      className: "caption font-light font-extreme-red" },
    text
  );
};
var subtractYears = function subtractYears(date, numberOfYears) {
  return (0, _moment2.default)(date).subtract(numberOfYears, "years").format(_date_formatter2.default.edpiDateFormat);
};
var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var CustomDateRangeComponent = function (_React$PureComponent) {
  _inherits(CustomDateRangeComponent, _React$PureComponent);

  function CustomDateRangeComponent(props) {
    _classCallCheck(this, CustomDateRangeComponent);

    var _this = _possibleConstructorReturn(this, (CustomDateRangeComponent.__proto__ || Object.getPrototypeOf(CustomDateRangeComponent)).call(this, props));

    _initialiseProps.call(_this);

    _this.DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
    var validFromDate = (0, _moment2.default)(_this.props.validFromDate, _this.DEFAULT_DATE_FORMAT);
    var validToDate = (0, _moment2.default)(_this.props.validToDate, _this.DEFAULT_DATE_FORMAT);
    var fromDate = (0, _moment2.default)(subtractYears(validToDate, 1)).isBefore(validFromDate) || _this.props.sinceInceptionIsDefault ? validFromDate : (0, _moment2.default)(subtractYears(validToDate, 1));
    var toDate = (0, _moment2.default)(_this.props.validToDate);

    var selectedDateOption = _this.getDefaultSelectedDateOption(validFromDate, validToDate);
    var selectedDateOptionTranslateKey = _this.getDefaultSelectedDateOptionTranslationKey(validFromDate, validToDate);

    _this.maxDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(validToDate, _this.DEFAULT_DATE_FORMAT));
    _this.minDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(validFromDate, _this.DEFAULT_DATE_FORMAT));

    _this.setFilteredData(fromDate, toDate);

    _this.state = {
      fromDate: fromDate,
      toDate: toDate,
      validFromDate: validFromDate,
      validToDate: validToDate,
      selectedDateOption: selectedDateOption,
      selectedDateOptionTranslateKey: selectedDateOptionTranslateKey,
      errorMessage: ''
    };

    _this.errorMessages = ["From Date has to be less than to date.", "To Date cannot be less than from date", "From Date cannot be same as To date", "To Date cannot be same as From date", _this.defaultOutOfRangeErrorMessage(), 'No Data within the selected date'];

    _this.renderDateRangeDropdown = _this.renderDateRangeDropdown.bind(_this);
    _this.renderCustomDatePickers = _this.renderCustomDatePickers.bind(_this);
    _this.breakpointIsBetweenOneAndThree = _this.breakpointIsBetweenOneAndThree.bind(_this);
    _this.setRef = _this.setRef.bind(_this);
    _this.resetErrorState = _this.resetErrorState.bind(_this);
    _this.onChangeFromDate = _this.onChangeFromDate.bind(_this);
    _this.onChangeToDate = _this.onChangeToDate.bind(_this);
    _this.getMonthAndYearDropdowns = _this.getMonthAndYearDropdowns.bind(_this);
    _this.setCustomDateRangeDropdown = _this.setCustomDateRangeDropdown.bind(_this);
    _this.handleOutOfRangeDate = _this.handleOutOfRangeDate.bind(_this);
    _this.defaultOutOfRangeErrorMessage = _this.defaultOutOfRangeErrorMessage.bind(_this);
    _this.generateDateRangeRow = _this.generateDateRangeRow.bind(_this);
    _this.getDefaultSelectedDateOption = _this.getDefaultSelectedDateOption.bind(_this);
    _this.getDefaultSelectedDateOptionTranslationKey = _this.getDefaultSelectedDateOptionTranslationKey.bind(_this);
    return _this;
  }

  _createClass(CustomDateRangeComponent, [{
    key: "renderDateRangeDropdown",
    value: function renderDateRangeDropdown() {
      var dateRangeDropdownObj = null;

      if (this.props.showDropdown) {
        dateRangeDropdownObj = _react2.default.createElement(_date_range_dropdown2.default, {
          additionalClassName: "",
          dateRangeItems: this.dateRangeItems,
          setRef: this.setRef,
          parentProps: this.props,
          state: this.state });
      }

      return dateRangeDropdownObj;
    }
  }, {
    key: "renderCustomDatePickers",
    value: function renderCustomDatePickers() {
      var _this2 = this;

      return _react2.default.createElement(
        "div",
        { className: "display-inline" },
        _react2.default.createElement(
          "div",
          { className: "display-inline-block margin-top-0 margin-right-10 text-top", "data-testid": "from-date-picker" },
          _react2.default.createElement(
            "div",
            { className: 'margin-bottom-5 tag-2' + (this.breakpointIsBetweenOneAndThree() ? ' margin-top-5' : '') },
            _string_utility2.default.renderFormattedLabel("FROM", "pdp-custom-date-range-date-from-label")
          ),
          _react2.default.createElement(
            "span",
            { className: "font-light caption", style: { 'lineHeight': '1.25' } },
            _react2.default.createElement(
              _click_or_escape_outside2.default,
              {
                id: "from-dropdown",
                ref: "from_dropdown_ref",
                key: "FROM",
                onClose: function onClose() {
                  _this2.resetErrorState();
                } },
              _react2.default.createElement(_single_date_picker_wrapper2.default, {
                id: this.props.id + "-from-date",
                date: this.state.fromDate,
                minDate: this.minDate,
                maxDate: (0, _moment2.default)(this.maxDate).format(this.DEFAULT_DATE_FORMAT),
                onChangeDate: this.onChangeFromDate,
                onFocusChangeCallback: function onFocusChangeCallback() {
                  _this2.setCustomDateRangeDropdown();
                },
                dateFormat: this.props.dateFormat,
                renderMonthElement: this.getMonthAndYearDropdowns() })
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "display-inline-block margin-top-0 margin-right-10 text-top", "data-testid": "to-date-picker" },
          _react2.default.createElement(
            "div",
            { className: 'margin-bottom-5 tag-2' + (this.breakpointIsBetweenOneAndThree() ? ' margin-top-5' : '') },
            _string_utility2.default.renderFormattedLabel("TO", "pdp-custom-date-range-date-to-label")
          ),
          _react2.default.createElement(
            "span",
            { className: "font-light caption", style: { 'lineHeight': '1.25' } },
            _react2.default.createElement(
              _click_or_escape_outside2.default,
              {
                id: "to-dropdown",
                ref: "to_dropdown_ref",
                key: "TO",
                onClose: function onClose() {
                  _this2.resetErrorState();
                } },
              _react2.default.createElement(_single_date_picker_wrapper2.default, {
                id: this.props.id + "-to-date",
                date: this.state.toDate,
                minDate: (0, _moment2.default)(this.minDate).add(1, 'day').format(this.DEFAULT_DATE_FORMAT),
                maxDate: (0, _moment2.default)(this.maxDate).add(1, 'day'),
                onChangeDate: this.onChangeToDate,
                onFocusChangeCallback: function onFocusChangeCallback() {
                  _this2.setCustomDateRangeDropdown();
                },
                dateFormat: this.props.dateFormat,
                renderMonthElement: this.getMonthAndYearDropdowns() })
            )
          )
        )
      );
    }
  }, {
    key: "setRef",
    value: function setRef(refId) {
      var _this3 = this;

      return function (el) {
        return _this3[refId] = el;
      };
    }
  }, {
    key: "resetErrorState",
    value: function resetErrorState() {
      var _state = this.state,
          fromDate = _state.fromDate,
          toDate = _state.toDate,
          validFromDate = _state.validFromDate,
          validToDate = _state.validToDate,
          error = _state.error,
          errorMessage = _state.errorMessage;

      if (error === "extreme") {
        this.props.tooltip.closeTooltip();
        this.setState({
          error: "moderate",
          errorId: null,
          fromDate: !(0, _ramda.isEmpty)(errorMessage) ? validFromDate : fromDate,
          toDate: !(0, _ramda.isEmpty)(errorMessage) ? validToDate : toDate,
          errorMessage: ''
        });
      }
    }
  }, {
    key: "onChangeFromDate",
    value: function onChangeFromDate(fromDate) {
      var validToDate = this.state.validToDate;

      var errorMessage = "";

      if ((0, _ramda.isNil)(fromDate) || fromDate.startOf('day').isBefore(this.minDate, this.DEFAULT_DATE_FORMAT)) {
        this.handleOutOfRangeDate(this.props.id + "-from-date");
        return false;
      }
      if (fromDate.isAfter(validToDate)) {
        errorMessage = "pdp-custom-date-range-error-message-prior-to-to-date";
      } else if (fromDate.isSame(validToDate)) {
        errorMessage = "pdp-custom-date-range-error-message-from-date-same-as-to-date";
      }
      this.validateDate(errorMessage, fromDate, validToDate, this.props.id + "-from-date");
    }
  }, {
    key: "onChangeToDate",
    value: function onChangeToDate(toDate) {
      var validFromDate = this.state.validFromDate;

      var errorMessage = "";

      if ((0, _ramda.isNil)(toDate) || toDate.startOf('day').isAfter(this.maxDate)) {
        this.handleOutOfRangeDate(this.props.id + "-to-date");
        return false;
      }
      if (toDate.isBefore(validFromDate, this.DEFAULT_DATE_FORMAT)) {
        errorMessage = "pdp-custom-date-range-error-message-prior-to-from-Date";
      } else if (toDate.isSame(validFromDate, "day") && toDate.isSame(validFromDate, "month") && toDate.isSame(validFromDate, "year")) {
        errorMessage = "pdp-custom-date-range-error-message-to-date-same-as-from-date";
      }
      this.validateDate(errorMessage, validFromDate, toDate, this.props.id + "-to-date");
    }
  }, {
    key: "setFilteredData",
    value: function setFilteredData(fromDate, toDate) {
      var normalizedFromDate = _moment2.default.utc((0, _moment2.default)(fromDate.toDate()).startOf('date'));
      var normalizedToDate = _moment2.default.utc((0, _moment2.default)(toDate.toDate()).endOf('date'));
      var isFilteredDataAvailable = this.props.filterData(normalizedFromDate, normalizedToDate);

      if (!isFilteredDataAvailable) {
        return 'pdp-custom-date-range-error-message-no-data';
      }

      return '';
    }
  }, {
    key: "getMonthAndYearDropdowns",
    value: function getMonthAndYearDropdowns() {
      var _this4 = this;

      var years = [];
      for (var i = this.minDate.year(); i <= this.maxDate.year(); i++) {
        years.push(_react2.default.createElement(
          "option",
          { value: i, "data-testId": this.props.id + "-year-dropdown-" + i, id: "historical-nav-year-dropdown-" + i },
          i
        ));
      }

      return function (_ref) {
        var month = _ref.month,
            onMonthSelect = _ref.onMonthSelect,
            onYearSelect = _ref.onYearSelect;
        return _react2.default.createElement(
          "div",
          { style: { display: 'flex', justifyContent: 'center' } },
          _react2.default.createElement(
            "div",
            { "data-testId": _this4.props.id + "-month-dropdown", id: "historical-nav-month-dropdown" },
            _react2.default.createElement(
              "select",
              {
                value: month.month(),
                onChange: function onChange(e) {
                  onMonthSelect(month, e.target.value);
                } },
              _moment2.default.monthsShort().map(function (label, value) {
                return _react2.default.createElement(
                  "option",
                  {
                    "data-testId": _this4.props.id + "-month-dropdown-" + value,
                    id: "historical-nav-month-dropdown-" + value,
                    value: value },
                  label
                );
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { "data-testId": _this4.props.id + "-year-dropdown", id: "historical-nav-year-dropdown" },
            _react2.default.createElement(
              "select",
              {
                value: month.year(),
                onChange: function onChange(e) {
                  onYearSelect(month, e.target.value);
                } },
              years
            )
          )
        );
      };
    }
  }, {
    key: "defaultOutOfRangeErrorMessage",
    value: function defaultOutOfRangeErrorMessage() {
      var dateRangeArray = this.props.dateRangeArray;

      if ((0, _functional_utility.isNilOrEmpty)(dateRangeArray)) {
        return "Please enter a date within the date range";
      }
      return "Please enter a date within the date range " + dateRangeArray[0] + " - " + (0, _ramda.last)(dateRangeArray) + ".";
    }
  }, {
    key: "setCustomDateRangeDropdown",
    value: function setCustomDateRangeDropdown() {
      this.setState({
        selectedDateOption: 'Custom Date Range',
        selectedDateOptionTranslateKey: 'dropdown-custom-date-range',
        selectedDateOptionValue: 'custom'
      });
    }
  }, {
    key: "handleOutOfRangeDate",
    value: function handleOutOfRangeDate(label) {
      var _this5 = this;

      var _state2 = this.state,
          fromDate = _state2.fromDate,
          toDate = _state2.toDate;
      var id = this.props.id;

      this.setState({
        fromDate: label === id + '-from-date' ? null : fromDate,
        toDate: label === id + '-to-date' ? null : toDate,
        errorMessage: "pdp-custom-date-range-error-message-out-of-range"
      }, function () {
        return _this5.renderToolTipErrorMessage(label, "pdp-custom-date-range-error-message-out-of-range", {
          toolTipWidth: "254px",
          toolTipContentWidth: "100%"
        });
      });
    }
  }, {
    key: "generateDateRangeRow",
    value: function generateDateRangeRow(value, displayValue, translationKey, key) {
      return _react2.default.createElement(
        "div",
        { key: key, "data-option-value": value, "data-translation-key": translationKey,
          onClick: this.changeDropDownFilter, "data-display-value": displayValue,
          className: "dropdown-list-item", role: "option" },
        _react2.default.createElement(
          "span",
          { className: "font-light caption", "data-option-value": value,
            "data-translation-key": translationKey, "data-display-value": displayValue },
          _string_utility2.default.renderFormattedLabel(displayValue, translationKey)
        )
      );
    }
  }, {
    key: "breakpointIsBetweenOneAndThree",
    value: function breakpointIsBetweenOneAndThree() {
      return this.props.breakpoint <= 3;
    }
  }, {
    key: "getDefaultSelectedDateOption",
    value: function getDefaultSelectedDateOption(fromDate, toDate) {
      var result = 'Since Inception';
      if (!(0, _ramda.isNil)(toDate) && !(0, _ramda.isNil)(fromDate) && !this.props.sinceInceptionIsDefault) {
        var toDateMinusOneYear = subtractYears(toDate, 1);
        if (fromDate.isBefore(toDateMinusOneYear)) {
          result = 'Last 1 year';
        }
      }
      return result;
    }
  }, {
    key: "getDefaultSelectedDateOptionTranslationKey",
    value: function getDefaultSelectedDateOptionTranslationKey(fromDate, toDate) {
      var result = 'since-inception';
      var toDateMinusOneYear = subtractYears(toDate, 1);
      if (!(0, _ramda.isNil)(toDate) && !(0, _ramda.isNil)(fromDate) && !this.props.sinceInceptionIsDefault) {
        if (fromDate.isBefore(toDateMinusOneYear)) {
          result = 'dropdown-last-1-year';
        }
      }
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { "data-testid": "customDateRangeComponent", className: "font-regular tag" },
        this.renderDateRangeDropdown(),
        this.renderCustomDatePickers()
      );
    }
  }]);

  return CustomDateRangeComponent;
}(_react2.default.PureComponent);

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.validateDate = function (errorMessage, fromDate, toDate, label) {
    if ((0, _ramda.isEmpty)(errorMessage)) {
      errorMessage = _this6.setFilteredData(fromDate, toDate);

      if ((0, _ramda.isEmpty)(errorMessage)) {
        _this6.setState({
          fromDate: fromDate,
          toDate: toDate,
          validFromDate: fromDate,
          validToDate: toDate,
          errorMessage: errorMessage
        }, _this6.props.tooltip.closeTooltip());
      }
    }

    if (!(0, _ramda.isEmpty)(errorMessage)) {
      _this6.setState({
        errorMessage: errorMessage
      }, function () {
        return _this6.renderToolTipErrorMessage(label, errorMessage, {
          toolTipWidth: "254px",
          toolTipContentWidth: "100%"
        });
      });
    }
  };

  this.renderToolTipErrorMessage = function (elementId, errorKey) {
    var additionalProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _props = _this6.props,
        id = _props.id,
        validFromDate = _props.validFromDate,
        validToDate = _props.validToDate,
        tooltip = _props.tooltip;

    var tooltipMessage = null;
    var values = {
      startDate: _date_formatter2.default.getLocalFormattedDate((0, _moment2.default)(validFromDate).format(_this6.DEFAULT_DATE_FORMAT)),
      endDate: _date_formatter2.default.getLocalFormattedDate((0, _moment2.default)(validToDate).format(_this6.DEFAULT_DATE_FORMAT))
    };

    if (errorKey === 'pdp-custom-date-range-error-message-out-of-range') {
      tooltipMessage = _string_utility2.default.renderFormattedLabel(_this6.errorMessages[4], errorKey, values);
    } else if (errorKey === 'pdp-custom-date-range-error-message-prior-to-to-date') {
      tooltipMessage = _string_utility2.default.renderFormattedLabel(_this6.errorMessages[0], errorKey, values);
    } else if (errorKey === 'pdp-custom-date-range-error-message-from-date-same-as-to-date') {
      tooltipMessage = _string_utility2.default.renderFormattedLabel(_this6.errorMessages[2], errorKey);
    } else if (errorKey === 'pdp-custom-date-range-error-message-prior-to-from-Date') {
      tooltipMessage = _string_utility2.default.renderFormattedLabel(_this6.errorMessages[1], errorKey, values);
    } else if (errorKey === 'pdp-custom-date-range-error-message-to-date-same-as-from-date') {
      tooltipMessage = _string_utility2.default.renderFormattedLabel(_this6.errorMessages[3], errorKey);
    } else if (errorKey === 'pdp-custom-date-range-error-message-no-data') {
      tooltipMessage = _string_utility2.default.renderFormattedLabel(_this6.errorMessages[5], errorKey);
    }

    tooltipMessage = setTooltipWrapper(tooltipMessage);
    var el = document.getElementById(elementId);
    var elHeight = el.offsetHeight;
    var elWidth = el.getBoundingClientRect().left;
    var elRect = el.getBoundingClientRect();
    var arrowHeight = 4;
    var offsetArrowHeight = 4;
    var elPadding = 10;
    var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
    var toolTipWidth = el.offsetWidth;

    var elOffset = (0, _ramda.mergeDeepRight)({
      top: elRect.top + docTop + arrowHeight + elHeight - offsetArrowHeight,
      left: elWidth,
      arrowPosition: elRect.left - elWidth - elPadding + (elRect.right - elRect.left) / 8,
      toolTipWidth: toolTipWidth,
      toolTipContentWidth: toolTipWidth,
      showCrossIcon: false
    }, additionalProps);

    _this6.setState({
      error: "extreme",
      errorId: elementId
    });
    elementId === id + '-from-date' ? _this6.refs.from_dropdown_ref.handleOpen() : _this6.refs.to_dropdown_ref.handleOpen();
    tooltip.openTooltip(elOffset, null, tooltipMessage, false);
  };

  this.dateRangeItems = function () {
    var dateRangeArray = _this6.props.dateRangeArray;

    var count = _this6.props.count;

    var items = mapIndexed(function (dateRangeOption, index) {
      return _this6.generateDateRangeRow(dateRangeOption.value, dateRangeOption.displayValue, dateRangeOption.translationKey, index);
    }, dateRangeArray).slice(0, count);

    items.push(_this6.generateDateRangeRow("custom", "Custom Date Range", "dropdown-custom-date-range", dateRangeArray.length));
    return items;
  };

  this.getFilteredData = function (dateOption) {
    var toDate = _this6.state.toDate;
    var filteredDate = _moment2.default.utc(toDate).subtract(Number(dateOption), 'months');
    return _collection_utility.CollectionUtility.filter(_this6.props.historicalNAVList, function (performance) {
      return performance.epochDate >= filteredDate;
    });
  };

  this.changeDropDownFilter = function (event) {
    var fromDate = void 0,
        toDate = void 0;

    var target = (0, _ramda.isNil)(event.target.getAttribute('data-option-value')) ? event.target.parentNode : event.target;
    var selectedOptionValue = target.getAttribute("data-option-value");
    var selectedDisplayValue = target.getAttribute("data-display-value");
    var selectedTranslateKey = target.getAttribute("data-translation-key");

    if (selectedOptionValue === '0') {
      toDate = (0, _moment2.default)(_this6.props.validToDate);
      fromDate = (0, _moment2.default)(_this6.props.validFromDate);
    } else if (selectedOptionValue === 'custom') {
      toDate = (0, _moment2.default)(_this6.state.validToDate);
      fromDate = _moment2.default.utc(toDate).subtract(Number(_this6.state.selectedDateOptionValue), 'months');
    } else {
      var dateOption = Number(selectedOptionValue);
      toDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat((0, _moment2.default)(_this6.state.validToDate), _this6.DEFAULT_DATE_FORMAT));
      fromDate = _date_formatter2.default.calculateFromDateByDateOptionList(dateOption, _this6.state.validFromDate, _this6.state.validToDate);
    }

    _this6.props.updateParent({
      fromDate: fromDate,
      toDate: toDate
    });

    _this6.setState({
      fromDate: fromDate,
      toDate: toDate,
      selectedDateOption: selectedDisplayValue,
      selectedDateOptionTranslateKey: selectedTranslateKey
    });
    _this6.validateDate("", fromDate, toDate, _this6.props.id + "-to-date");
  };
};

exports.default = (0, _reactIntl.injectIntl)(CustomDateRangeComponent);